import instance from "@/services/api";

export const supplyAgreementTemplateAPI = {
  async checkAccess() {
    return await instance().get('/handbook/supply_agreement_template/check_access/').then(res => res?.data)
  },
  async getList() {
    return await instance().get('/handbook/supply_agreement_template/read/').then(res => res?.data)
  },
  async save(formData) {
    return await instance().post('/handbook/supply_agreement_template/save/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res?.data)
  },
  async delete(supply_agreement_template_id) {
    return await instance().delete(`/handbook/supply_agreement_template/${supply_agreement_template_id}/delete/`).then(res => res?.data)
  },
  async download(supply_agreement_template_id) {
    const response = await instance().get(`/handbook/supply_agreement_template/${supply_agreement_template_id}/download/`, {
      responseType: 'blob'
    });
    return response;
  },
  async toggleActive(supply_agreement_template_id, is_active) {
    return await instance().post(`/handbook/supply_agreement_template/${supply_agreement_template_id}/toggle_active/`, {
      is_active
    }).then(res => res?.data)
  },
}
